import { render, staticRenderFns } from "./MainJouCoinCard.vue?vue&type=template&id=7c2a2012&scoped=true&"
import script from "./MainJouCoinCard.vue?vue&type=script&lang=js&"
export * from "./MainJouCoinCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouCoinCard.vue?vue&type=style&index=0&id=7c2a2012&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a2012",
  null
  
)

export default component.exports